import { PlayCircleIcon } from '@carboncopyco/icons';
import type { Play } from '@carboncopyco/types';
import { Button, TextBase, TextCaption, TooltipBubble } from '@carboncopyco/ui';
import { PlayEventNames, useAnalytics } from '@carboncopyco/utils';
import classNames from 'classnames';
import { playParentEntityToIdKey } from '../PresentationModals/GiveADemoFlowModal/consts';
import { useConsoleState } from './ConsoleContext';
import { iconByAssetType, iconTitleByAssetType } from './consts';

type QueuedPlayRowProps = { play: Play };

export const QueuedPlayRow = ({ play }: QueuedPlayRowProps) => {
  const { trackEvent } = useAnalytics();
  const { handlePlay } = useConsoleState();
  const {
    forClient,
    asset: { assetType, assetId, assetName = 'Untitled' },
    status,
  } = play;
  const isDisabled = status === 'deleted' || status === 'inactive';
  const Icon = iconByAssetType[assetType];

  return (
    <div className="hover:bg-ds-natural-50 flex items-center justify-between gap-2.5 w-full overflow-hidden px-6 h-16">
      <div className="flex items-center gap-2.5 overflow-hidden">
        <TooltipBubble
          title={iconTitleByAssetType[assetType]}
          placement="top"
        >
          <Icon />
        </TooltipBubble>

        <div className="overflow-hidden">
          <TooltipBubble
            title={assetName}
            placement="top"
          >
            <div className="truncate leading-ds-50">
              <TextBase
                label={assetName}
                color={
                  isDisabled ? 'text-ds-natural-200' : 'text-ds-natural-600'
                }
              />
            </div>
          </TooltipBubble>
          <TooltipBubble
            title={forClient}
            placement="top"
          >
            <div
              className={classNames(
                'truncate leading-ds-50',
                isDisabled ? 'text-ds-natural-100' : 'text-ds-natural-300'
              )}
            >
              <TextCaption
                label={forClient}
                lineHeight="leading-ds-50"
              />
            </div>
          </TooltipBubble>
        </div>
      </div>

      <Button
        disabled={isDisabled}
        icon={<PlayCircleIcon />}
        secondary
        link
        style={{ padding: '4px', borderRadius: '100%' }}
        onClick={() => {
          trackEvent(PlayEventNames.PLAY_CLICK_PLAY_NOW, {
            [playParentEntityToIdKey[assetType]]: assetId,
            location: 'Console.presentation_queue',
          });
          handlePlay(play);
        }}
      />
    </div>
  );
};
